<template>
	<div id="contest" :class='{"contest-pc":!flag == true,"contest-mobile":!flag == false}'>
		<div class="topNav">
			<ul>
				<li v-for='(tabItem,index) in navName' :key="index" @click="tabToggle(index)">
					<router-link :class='{"active": index == nowIndex}' :to=tabItem>{{index}}</router-link>
				</li>
			</ul>
		</div>
		<div v-if="nowIndex === '首页'" :class='{"banner":!flag}'>
			<img v-if="!flag" src="../../assets/bannar.png" alt="">
			<img class="banner-mobile" v-else src="../../assets/bannar-phone.png" alt="">
		</div>
		<div :style="option">
			<div v-if="nowIndex === '首页'" class="contest-info">
				<div @click="tabToggle('设计大赛')">
					<router-link name='dasai' :to="'/dasai'">
						<index-info :infotype="1" :dataInfo="indexInfoObj.dasai"></index-info>
					</router-link>
				</div>
				<div @click="tabToggle('“粤字号”成果')">
					<router-link name='chengguo' to='/chengguo'>
						<index-info :infotype="2" :dataInfo="indexInfoObj.chengguo"></index-info>
					</router-link>
				</div>
				<div @click="tabToggle('品牌扶贫')">
					<router-link name='fuping' to='/fuping'>
						<index-info :infotype="1" :dataInfo="indexInfoObj.fuping"></index-info>
					</router-link>
				</div>
				<div @click="tabToggle('联盟启动')">
					<router-link name='qidong' to='/qidong'>
						<index-info :infotype="2" :dataInfo="indexInfoObj.qidong"></index-info>
					</router-link>
				</div>
			</div>
			<router-view></router-view>
		</div>
	</div>
</template>

<script>
	var str = 'form';
	import title1png from '../../assets/1-title.png';
	import title2png from '../../assets/2-title.png';
	import title3png from '../../assets/3-title.png';
	import title4png from '../../assets/4-title.png';
	import sjdspng from '../../assets/1-sjds.png';
	import cgzspng from '../../assets/2-cgzs.png';
	import ppfppng from '../../assets/3-ppfp.png';
	import lmqdpng from '../../assets/4-lmqd.png';
	export default {
		name: 'show',
		components: {
			"indexInfo": () => import("../../components/indexInfo.vue")
		},
		data() {
			var flag = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			)
			return {
				flag: navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
				),
				option: {
					width: flag ? '' : '20rem',
					margin: flag ? '' : '0 auto',
					'margin-top': flag? '-50px': '-120px'
				},
				navName: {'首页':"/#",'设计大赛':"/dasai",'“粤字号”成果':"/chengguo",'品牌扶贫':"/fuping",'联盟启动':"/qidong"},
				
				indexInfoObj: {
					'dasai': {
						'titleImg': title1png,
						'infoImg': sjdspng,
						'info': '省农业农村厅发起“一村一品、一镇一业”粤字号品牌创意设计大赛，征集并评选出一批“粵字号”区域公用品牌创意设计作品，挖掘品牌文化、延伸品牌价值链、壮大我省区域公用品牌知名度和竞争力。大赛共收到参赛作品2126件，最终品牌徽标、品牌标语、品牌包装、品牌海报、品牌短视频五组分别评出一等奖1名、二等奖2名、三等奖4名，另外还评选出大赛优秀作品100名。'
					},
					'chengguo': {
						'titleImg': title2png,
						'infoImg':cgzspng,
						'info': '在省委省政府的高度重视下，2019年“粤字号”品牌进入转型升级的关键时期。随着现代农业产业园和“一村一品、一镇一业”的大力投入，通过打造品牌来促进地方特色产业发展成为了必由之路。农博会上正式发布“粤字号”2019年县域名特优新农产品区域公用品牌百强结果及2019年度最有价值十大区域公用品牌，“粤字号”品牌已成为广东产业兴旺、富民兴村的重要抓手。'
					},
					'fuping': {
						'titleImg': title3png,
						'infoImg':ppfppng,
						'info': '广东省委省政府历年来高度重视农产品品牌化建设，省农业农村厅深化推进“粤字号”农业知名品牌创建行动，我省195个区域公用品牌带动相对贫困村脱贫增收，“粤字号”品牌已成为乡村振兴、产业兴旺的重要抓手，成为实现农民增收、脱贫致富的根本途径和长久之策。'
					},
					'qidong': {
						'titleImg': title4png,
						'infoImg':lmqdpng,
						'info': '原农业部党组成员、国务院参事室特约研究员、中国农产品市场协会会长 张玉香，广东省农业农村厅 副厅长（正厅职）陈东与多个发起单位启动广东特色农产品区域公用品牌发展联盟，启动广东农业品牌目录制度建设，共同携手、共享资源，将“粤字号”农业品牌推向新的高度。'
					}

				}
			}
		},
		computed: {
			nowIndex :{
				get () {
					var namenav = this.navName,nowindex = '首页';
					for(var key in namenav) {
						if( this.$route.path == namenav[key]){
							nowindex = key;
						}
					}
					return nowindex;
				},
				set () {

				}
			}
		},
		methods: {
			tabToggle (index) {
				this.nowIndex = index
			}
		},
		mounted() {

		}
	}
</script>

<style lang="scss" scoped="scoped">
	@import '../../../public/base.css';
	.contest-pc {
		//overflow-x: hidden;
		width: 100%;
		background: url('../../assets/bg.png') repeat;
		position: relative;
		.topNav{
			width: 100%;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1;
			background: rgba(255,255,255,0.8);
			box-shadow: 0px 10px 40px #756969;
			ul{
				width: 980px;
				padding: 0px 10px;
				margin: 0 auto;
				li{
					display: inline-block;
					margin-right: 50px;
					font-size: 26px;
					line-height: 80px;
					.active{
						border-bottom: 2px solid rgb(228,30,40);
						color: rgb(228,30,40)
					}
					a{
						color: #333;
						padding-bottom: 8px;
					}
				}
			}
		}
		.banner{
			width: 100%;
			overflow: hidden;
			position: relative;
			height: 1375px;
			img{
				position: absolute;
				left: 50%;
				margin-left: -960px;
			}
		}
	}
	.contest-mobile {
		width: 100%;
		//overflow-x: hidden;
		background: url('../../assets/bg.png') repeat;
		position: relative;
		.banner-mobile{
			width: 100%;
		}
		.topNav{
			width: 100%;
			position: fixed;
			top: 0;
			left: 0;
			z-index: 1;
			background: rgba(255,255,255,0.8);
			box-sizing: border-box;
			box-shadow: 0px 6px 10px #918a8a;
			ul{
				width: 100%;
				padding: 0px 10px;
				box-sizing: border-box;
				li{
					display: inline-block;
					margin-right: 12px;
					font-size: 14px;
					line-height: 60px;
					.active{
						border-bottom: 2px solid rgb(228,30,40);
						color: rgb(228,30,40)
					}
					a{
						color: #333;
						padding-bottom: 8px;
					}
				}
			}
		}
		.banner{
			width: 100%;
			overflow: hidden;
			position: relative;
			height: 1375px;
			img{
				position: absolute;
				left: 50%;
				margin-left: -960px;
			}
		}
	}

</style>
